export const BUCKET_SETTINGS_ACTIVE_TAB_SET = 'BUCKET_SETTINGS_ACTIVE_TAB_SET';
export const BUCKET_SETTINGS_INFO_GET_REQUEST =
    'BUCKET_SETTINGS_INFO_GET_REQUEST';
export const BUCKET_SETTINGS_INFO_GET_SUCCESS =
    'BUCKET_SETTINGS_INFO_GET_SUCCESS';
export const BUCKET_SETTINGS_INFO_GET_FAILURE =
    'BUCKET_SETTINGS_INFO_GET_FAILURE';
